import actions from './actions';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  unmatchedTrendsList: null,
  loading: false,
  total: 0,
  filteredTotal: 0,
  filters: [],
  sortableColumns: [],
};

function onLoadRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters, sortableColumns } = payload;

  return {
    ...state,
    data,
    filters,
    total,
    filteredTotal,
    loading: false,
    sortableColumns,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_REQUEST]: onLoadRequest,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
